import './modal.css'

export default function Modal({ open, title, children, onClose, onSubmit, submitLabel='Create' }) {
    if (!open) return null
    return (
        <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
            <div className="modal-card" onClick={e=>e.stopPropagation()}>
                <div className="modal-head">
                    <div className="modal-title">{title}</div>
                    <button className="modal-x" aria-label="Close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">{children}</div>
                <div className="modal-foot">
                    <button className="btn ghost" onClick={onClose}>Cancel</button>
                    <button className="btn primary" onClick={onSubmit}>{submitLabel}</button>
                </div>
            </div>
        </div>
    )
}
